import { render } from "./CoinHistory.vue?vue&type=template&id=4bc64f93&ts=true"
import script from "./CoinHistory.vue?vue&type=script&lang=ts"
export * from "./CoinHistory.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__